"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icon = _interopRequireDefault(require("../icon"));

require("./styles.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function iconButton(_ref) {
  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      icon = _ref.icon;
  return /*#__PURE__*/_react.default.createElement("button", {
    onClick: onClick,
    type: "button",
    className: "icon-button ".concat(className),
    disabled: disabled
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    icon: icon,
    fixedWidth: true
  }));
}

iconButton.propTypes = {
  icon: _propTypes.default.string.isRequired,
  className: _propTypes.default.string,
  onClick: _propTypes.default.func,
  disabled: _propTypes.default.bool
};
var _default = iconButton;
exports.default = _default;